import * as React from 'react';
import { FontIcon } from '@fluentui/react/lib/Icon';
import { mergeStyleSets, mergeStyles } from '@fluentui/react';
import { useQuery } from '@tanstack/react-query';
import { fetchDocumentStatusInformation } from './Data';
import { useTranslation } from 'react-i18next';
import DocumentStatusInfoWrapper from '../styles/DocumentStatusInfoWrapper';
import MainContentWrapper from '../styles/MainContentWrapper';
import Links from '../styles/Links';

const iconClass = mergeStyles({
    fontSize: 150,
    height: 150,
    width: 150,
    margin: '0 25px',
});
const greenClass = { color: '#26c414' };
const redClass = { color: '#c41443' };

const classNames = mergeStyleSets({
    greenIcon: [greenClass, iconClass],
    redIcon: [redClass, iconClass],
    greenText: [greenClass],
    redText: [redClass]
});

export interface IDocumentStatusInfoContentProps {
}

export const DocumentStatusInfoContent = (props: IDocumentStatusInfoContentProps): React.ReactElement => {
    const statusInfoQuery = useQuery({
        queryKey: ['documentStatusInfo'],
        queryFn: () => fetchDocumentStatusInformation(props),
        refetchOnWindowFocus: true,
        retry: false
    });

    const { t } = useTranslation();

    return (
        <DocumentStatusInfoWrapper>
            <MainContentWrapper>
                {statusInfoQuery.isLoading &&
                    <>Lade...</>
                }
                {statusInfoQuery.data &&
                    <>
                        { statusInfoQuery.data.error ?
                            <>
                                <h1>Fehler</h1>
                                <div>{statusInfoQuery.data.error}</div>
                            </>
                        :
                            <>
                                { statusInfoQuery.data.publishedDocVersion === statusInfoQuery.data.requestedDocVersion ?
                                    <>
                                        <FontIcon aria-label="Accept" iconName="Accept" className={classNames.greenIcon} />
                                        <h1>{statusInfoQuery.data.publishedDocTitle}</h1>
                                        <h2 className={classNames.greenText}>{t('Strings.StatusText_ActiveDoc')}</h2>
                                        <div>
                                            Version {statusInfoQuery.data.publishedDocVersion}.0
                                        </div>
                                        <Links>
                                            <a href={statusInfoQuery.data.publishedDocEmbedUrl}>{t("Strings.OpenDocumentInBrowser")}</a>
                                            <a href={statusInfoQuery.data.publishedDocFileUrl}>{t("Strings.DownloadDocument")}</a>
                                            <a href={statusInfoQuery.data.publishedDocFolderUrl}>{t("Strings.OpenFolderInBrowser")}</a>
                                        </Links>
                                    </>
                                    : 
                                    <>
                                        <FontIcon aria-label="Accept" iconName="AlertSolid" className={classNames.redIcon} />
                                        <h1>{statusInfoQuery.data.publishedDocTitle}</h1>
                                        <h2 className={classNames.redText}>{t("Strings.StatusText_InactiveDoc")}</h2>
                                        <div>
                                            {t("Strings.MostCurrentVersionInfoText_Part1") }
                                            <b>{statusInfoQuery.data.requestedDocVersion}.0</b>
                                            {t("Strings.MostCurrentVersionInfoText_Part2") }
                                            <b>{statusInfoQuery.data.publishedDocVersion}.0</b>.
                                        </div>
                                        
                                        <Links>
                                            <a href={statusInfoQuery.data.publishedDocEmbedUrl}>{t("Strings.OpenMostCurrentVersionInBrowser")}</a>
                                            <a href={statusInfoQuery.data.publishedDocFileUrl}>{t("Strings.DownloadMostCurrentVersion")}</a>
                                            <a href={statusInfoQuery.data.publishedDocFolderUrl}>{t("Strings.OpenFolderInBrowser")}</a>
                                            { statusInfoQuery.data.requestedDocVersionUrl ?
                                                <a href={statusInfoQuery.data.requestedDocVersionUrl}>{t("Strings.OpenRequestedDocumentVersion")}</a>
                                                :
                                                <>{t("Strings.VersionDoesNotExist1")} { statusInfoQuery.data.requestedDocVersion } {t("Strings.VersionDoesNotExist2")}</>
                                            }
                                        </Links>                                        
                                    </>
                                }
                            </>
                        }
                    </>
                }
            </MainContentWrapper>
        </DocumentStatusInfoWrapper>
    );
}
